'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Icon$IconName() {
}
export { $c_Lpresto_Icon$IconName as $c_Lpresto_Icon$IconName };
$p = $c_Lpresto_Icon$IconName.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Icon$IconName;
/** @constructor */
function $h_Lpresto_Icon$IconName() {
}
export { $h_Lpresto_Icon$IconName as $h_Lpresto_Icon$IconName };
$h_Lpresto_Icon$IconName.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=presto.-Icon$-Icon-Name.js.map
